import { UNIT } from '../../constants/theme';

export const styles = () => ({
  titleStyle: {
    fontSize: UNIT * 0.875,
    color: 'black'
  },
  itemStyle: {
    paddingBottom: 0,
    paddingTop: 0
  },
  listStyle: {
    maxHeight: UNIT * 26.5,
    minHeight: UNIT * 6.25,
    overflow: 'auto'
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  connexionName: {
    textTransform: 'capitalize', fontSize: '12px'
  }
});
